<!--NOTICE: ALL STYLES NEED TO BE INLINE-->
<table cellpadding="0" cellspacing="0" style="width: 100%; margin-bottom: 16px; font-family: Arial, sans-serif; color: #444; font-size: 10px;border-style: none;">
    <tr>
        <!-- Profile Image -->
        <td valign="top" style="width: 110px; padding-right: 15px;">
            <img id="photo" alt="Photo" src="{{dbUserSS.agentInfo.profileImageUrl}}" style="width: 110px; height: 110px; object-fit: cover; border-radius: 50%;">
        </td>
        
        <!-- Agent Details -->
        <td valign="top">
            <table cellpadding="0" cellspacing="0" style="width: 100%;border-style: none;">
                <tr>
                    <td style="padding-bottom: 4px;">
                        <span style="color: #4A2F89; font-size: 14px; font-weight: bold;">{{dbUserSS.agentInfo.firstName}} {{dbUserSS.agentInfo.lastName}}</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;">
                        <span style="font-weight: bold;">{{dbUserSS.agentInfo.jobTitle}}</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;" *ngIf="dbUserSS.agentInfo.nmlsid">
                        <span>NMLS ID: {{dbUserSS.agentInfo.nmlsid}}</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;" *ngIf="dbUserSS.agentInfo.phone">
                        <span>Phone: {{dbUserSS.agentInfo.phone}}</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;" *ngIf="dbUserSS.agentInfo.username">
                        <span>Email: <a href="mailto:{{dbUserSS.agentInfo.username}}@mail.rfm.io" style="color: #4A2F89; text-decoration: none;">{{dbUserSS.agentInfo.username}}&#64;mail.rfm.io</a></span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;" *ngIf="!dbUserSS.agentInfo.username">
                        <span>Email: <a href="mailto:{{dbUserSS.agentInfo.email}}" style="color: #4A2F89; text-decoration: none;">{{dbUserSS.agentInfo.email}}</a></span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 8px;">
                        <span>Website: <a href="{{mloClientRegistrationLink}}" style="color: #4A2F89; text-decoration: none;">HomeDashboard</a></span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;">
                        <span style="font-weight: bold;">{{dbUserSS.company.name}}</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;">
                        <span>{{dbUserSS.company.address1}}, {{dbUserSS.company.city}}, {{dbUserSS.company.state}} {{dbUserSS.company.zipCode}}</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-bottom: 4px;">
                        <span>NMLS ID: 
                            <a href="https://www.nmlsconsumeraccess.org/EntityDetails.aspx/COMPANY/2445766" target="_blank" style="color: #4A2F89; text-decoration: none;">
                                2445766
                            </a>
                        </span>
                    </td>
                </tr>
            </table>
        </td>
    </tr>
    
    <!-- Opt-out and Scam Warning -->
    <tr>
        <td colspan="2" style="padding-top: 12px; font-size: 9px;">
            Prevent 3rd party solicitations at
            <a href="https://www.optoutprescreen.com/" style="font-weight: bold; color: #4A2F89; text-decoration: none;">OptOutPrescreen.com</a>
        </td>
    </tr>
    <tr>
        <td colspan="2" style="font-size: 9px;">
            Click below to protect yourself from scams
        </td>
    </tr>
</table>